import { ICellRendererParams, GridApi } from 'ag-grid-community';
import { isNil, isFunction, get, isEmpty } from 'lodash';

function setFocusedCell(): MethodDecorator {
  return <T>(
    target: { params: ICellRendererParams },
    propertyKey: string | symbol,
    descriptor: TypedPropertyDescriptor<T>,
  ): TypedPropertyDescriptor<T> => {
    const originalMethod = descriptor.value;

    if (!isFunction(originalMethod)) {
      throw new TypeError(
        `@setFocusedCell(): decorator can be applied only for methods.`,
      );
    }

    const wrapper = function (
      ...params: any[]
    ): ReturnType<typeof originalMethod> {
      const gridApi: GridApi = get(this, 'params.api');

      if (isEmpty(this.params)) {
        // eslint-disable-next-line no-console
        console.warn(
          '@setFocusedCell(): ICellRendererParams params is empty this only working when you have it.',
        );
      }

      if (!isNil(gridApi) && isNil(gridApi.getFocusedCell())) {
        queueMicrotask(() =>
          gridApi.setFocusedCell(
            this.params.node.rowIndex,
            this.params.column.getColId(),
          ),
        );
      }

      return originalMethod.apply(this, params);
    };

    return {
      ...descriptor,
      value: wrapper as any,
    };
  };
}

export { setFocusedCell };
